var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.component_key,staticClass:"MembershipLocationMark",class:_vm.component_class,on:{"pointerdown":_vm.click_handle}},[_c('div',{staticClass:"MembershipLocationMarkTexture"})])
}
var staticRenderFns = []

export { render, staticRenderFns }